<template>
	<div class="film">
		<mt-header title="导航">
		  <router-link to="/" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		</mt-header>
		222
	</div>
</template>

<script>
	import Vue from 'vue'
	export default {
		data () {
		    return {

		    }
		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style>
	.film .mint-header {
		font-size: 1.2rem;
		background-color: #FE4C40;
	}
</style>



// WEBPACK FOOTER //
// src/view/film.vue